// The Lab: visual explorers for the mathematics hiding inside voice leading —
// orbifolds, symmetric chords, parsimonious graphs, evenness. Hub + exhibits.

import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { LAB_EXHIBITS } from '@/components/lab/exhibits';
import { APP_ROUTES } from '@/navigation';

export function LabPage() {
  const { exhibitId } = useParams();
  const exhibit = LAB_EXHIBITS.find((e) => e.id === exhibitId);

  if (exhibit?.Component) {
    const Component = exhibit.Component;
    return (
      <div>
        <div className="page-header">
          <Link to={APP_ROUTES.lab} className="lab-back" data-testid="lab-back">
            <ArrowLeft size={15} aria-hidden="true" />
            Lab
          </Link>
          <h1>{exhibit.title}</h1>
          <p>{exhibit.tagline}</p>
        </div>
        <Component />
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1>Lab</h1>
        <p>
          Interactive diagrams of the mathematics of voice leading: chord spaces, symmetric chords
          and voice-leading graphs. Each one can be played.
        </p>
      </div>
      <div className="lab-grid" data-testid="lab-grid">
        {LAB_EXHIBITS.map((e) =>
          e.Component ? (
            <Link
              key={e.id}
              to={`${APP_ROUTES.lab}/${e.id}`}
              className="lab-card"
              data-testid={`lab-card-${e.id}`}
            >
              <div className="lab-card-tagline">{e.tagline}</div>
              <h3>{e.title}</h3>
              <p>{e.blurb}</p>
              <span className="lab-card-cta">
                Open
                <ArrowRight size={15} aria-hidden="true" />
              </span>
            </Link>
          ) : (
            <div key={e.id} className="lab-card soon" data-testid={`lab-card-${e.id}`}>
              <div className="lab-card-tagline">{e.tagline}</div>
              <h3>{e.title}</h3>
              <p>{e.blurb}</p>
              <span className="lab-card-cta">Coming soon</span>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
